var YouAreI = require('youarei');


function cloneUrlParams(source_url, out_url, params) {
    var copy_all = !params;
    var source_uri = new YouAreI(source_url);
    var out_uri = new YouAreI(out_url);
    var source_query = source_uri.query_get();
    var out_query = out_uri.query_get();
    Object.keys(source_query).forEach(function (param_name) {
        var not_param_in_out_url = !out_query.hasOwnProperty(param_name);
        var can_copy_param = copy_all || params.indexOf(param_name) >= 0;
        if (not_param_in_out_url && can_copy_param) {
            var val = {};
            val[param_name] = source_query[param_name];
            out_uri.query_push(val);
        }
    });
    return out_uri.to_string();
}


module.exports = {
    cloneUrlParams: cloneUrlParams
};



/*****************
 ** WEBPACK FOOTER
 ** ./client/helpers/url_tools.js
 ** module id = 11
 ** module chunks = 0
 **/